/**
 * Garantee that all fares returned has a usdTotalPrice property
 * @param {*} fares
 */
const makeSureTheseAreFlatFares = (fares) => {
  if (fares && fares.length) {
    const normalizedFares = [];
    fares.forEach((item) => {
      if (item.usdTotalPrice) {
        normalizedFares.push(Object.assign({}, item));
      }
    });
    return normalizedFares;
  }
  return [];
};

/**
 * Normalize histograms as flat fares
 * @param {*} histograms
 */
const histogramsToFlatFares = (histograms) => {
  if (histograms && histograms.length) {
    const normalizedFares = [];
    histograms.forEach((item) => {
      if (item.fareItem && item.fareItem.usdTotalPrice) {
        normalizedFares.push(Object.assign({}, item.fareItem));
      }
    });
    return normalizedFares;
  }
  return [];
};

/**
 * Normalize popularDestinations as flat fares
 * @param {*} popularDestinations
 */
const popularDestinationsToFlatFares = (popularDestinations) => {
  if (popularDestinations && popularDestinations.data && popularDestinations.data.length) {
    let normalizedFares = [];
    popularDestinations.data.forEach((item) => {
      if (item.fares && item.fares.length) {
        normalizedFares = [].concat(normalizedFares, makeSureTheseAreFlatFares(item.fares));
      }
    });
    return normalizedFares;
  }
  return [];
};

/**
 * PopularDestinations as flatFares
 * @param {*} popularDestinations
 * @param {*} topPopularDestination
 */
const featuredDestinationToFlatFares = (popularDestinations, topPopularDestination) => {
  if (topPopularDestination && popularDestinations && popularDestinations.length) {
    const normalizedFares = makeSureTheseAreFlatFares(popularDestinations);
    if (topPopularDestination.usdTotalPrice) {
      normalizedFares.push(Object.assign({}, topPopularDestination));
    }
    return normalizedFares;
  }
  return [];
};

export {
  makeSureTheseAreFlatFares,
  histogramsToFlatFares,
  popularDestinationsToFlatFares,
  featuredDestinationToFlatFares,
};
